import PropTypes from 'prop-types'
import React, { createContext, useContext, useState } from 'react'

const UpgradeDialogContext = createContext()

export const UpgradeDialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const showUpgradeDialog = () => setIsOpen(true)
  const hideUpgradeDialog = () => setIsOpen(false)

  return (
    <UpgradeDialogContext.Provider
      value={{ isOpen, showUpgradeDialog, hideUpgradeDialog }}
    >
      {children}
    </UpgradeDialogContext.Provider>
  )
}

UpgradeDialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useUpgradeDialog = () => useContext(UpgradeDialogContext)
